import moment from 'moment-timezone';
import {Call} from "../store/features/calls/callsService";

export const  formatDate = (date: Date , intl:any) => {

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
        return intl.formatMessage({ id: 'time.today' });
    } else if (date.toDateString() === yesterday.toDateString()) {
        return intl.formatMessage({ id: 'time.yesterday' });
    } else {
        const options: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }
}
export const DateFormatter = ( dateString: any, noTime?: boolean ) => {

    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric' };
    const timeString = date.toLocaleTimeString(undefined, options).toLowerCase();
    const dateStringFormatted = date.toLocaleDateString();

    if (noTime) {
        return dateStringFormatted;
    }
    const formattedDate = `${timeString}, ${dateStringFormatted}`;

    return formattedDate
};
export const formatDateDayMonth = (date: Date) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric'};
    return date.toLocaleDateString('en-US', options);
}

  const getHoursFromDate = (date: any) => {
    const hours = date.getHours();
    let minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes;
  }

export function getTimeAgo(finishedAt: Date | null) {
    if (!finishedAt) return ''; // Handle the case when finishedAt is null

    const finishedDate = new Date(finishedAt);
    if (Number.isNaN(finishedDate.getTime())) return '';

    const now = new Date();
    const diffMilliseconds = now.getTime() - finishedDate.getTime();
    const diffMinutes = Math.floor(diffMilliseconds / (1000 * 60));

    if (diffMinutes < 1) {
        return 'just now';
    }

    if (diffMinutes < 60) {
        return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    }

    if (diffMinutes < 720) {
        const diffHours = Math.floor(diffMinutes / 60);
        return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    }

    // Beyond the relative window the bare clock time is ambiguous — yesterday
    // and last month both read as "14:32" — so spell the date out, matching how
    // call history renders older entries.
    return `${formatDateDayMonth(finishedDate)}, ${getHoursFromDate(finishedDate)}`;
}
export function groupCallsByDate(calls: Call[], intl: any) {
    if (!calls) return;
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const groups: { [key: string]: Call[] } = {};

    const otherDates: Record<string, Call[]> = {};

    calls.forEach((call: Call) => {
        const callDate = new Date(call.startedAt);

        if (isSameDate(callDate, today)) {
            if (!groups['Today']) {
                groups['Today'] = [];
            }
            groups['Today'].push(call);
        } else if (isSameDate(callDate, yesterday)) {
            if (!groups['Yesterday']) {
                groups['Yesterday'] = [];
            }
            groups['Yesterday'].push(call);
        } else {
            const dateKey = formatDate(callDate, intl);
            if (!otherDates[dateKey]) {
                otherDates[dateKey] = [];
            }
            otherDates[dateKey].push(call);
        }
    });

    Object.values<Call[]>(groups).forEach((group: Call[]) => {
        group.sort((a: Call, b: Call) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime());
    });

    Object.values<Call[]>(otherDates).forEach((group: Call[]) => {
        group.sort((a: Call, b: Call) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime());
    });


    const nonEmptyGroups = Object.fromEntries(
        Object.entries(groups).filter(([, calls]) => calls && calls.length > 0)
    );

    return { ...nonEmptyGroups, ...otherDates };
}

function isSameDate(date1: Date, date2:Date) {
    return date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear();
}

export const formattedTime = (timer:number) => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
export const duration = (startedAt: any, finishedAt: any) => {
    if(!startedAt || !finishedAt) return '0 sec';
    const startedDate = new Date(startedAt);
    const finishedDate = new Date(finishedAt);
    const diff = finishedDate.getTime() - startedDate.getTime();
    const minutes = Math.floor(diff / 60000);
    const seconds = ((diff % 60000) / 1000).toFixed(0);
    return `${minutes ? minutes + ' min'  : ''}  ${parseInt(seconds) < 10 ? '0' : ''}${seconds} sec`;
}

export const flatDurationInMinutes = (startedAt: any, finishedAt: any) => {
    const startedDate = new Date(startedAt);
    const finishedDate = new Date(finishedAt);
    const diff = finishedDate.getTime() - startedDate.getTime();
    const minutes = Math.floor(diff / 60000);
    return minutes;
}

export function timeSince(startedAt: string | number | Date) {
    const now = new Date().getTime();
    const started = new Date(startedAt).getTime();

    if (isNaN(started)) {
        console.error('Invalid date format for startedAt:', startedAt);
        return '00:00:00';
    }
    const diffInSeconds = Math.floor((now - started) / 1000);

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    if (hours > 0) {
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }
    return `${formattedMinutes}:${formattedSeconds}`;
}


export function convertAmPmToIso(timeString: string, timeZone: string): string {

    const time24 = moment(timeString, ['h:mm A']).format('HH:mm');
    const currentDate = moment.tz(timeZone).format('YYYY-MM-DD');


    const timeInZone = moment.tz(`${currentDate} ${time24}`, 'YYYY-MM-DD HH:mm', timeZone);
    const isoTime = timeInZone.format('HH:mmZ');

    return isoTime;
}


export function convertIsoToAmPm(timeString: string): string {

    const isoTime = `1970-01-01T${timeString}`;

    const date = moment.parseZone(isoTime);
    if (!date.isValid()) {
        throw new Error('Invalid time format');
    }

    const formattedTime = date.format('h:mm A');
    return formattedTime;
}

export function convertToISOFormat(dateString: string, timeString: string) {

    const combinedDateTimeString = `${dateString} ${timeString}`;
    const momentDate = moment(combinedDateTimeString, "MMM DD, YYYY h:mm A");

    const isoStringWithOffset = momentDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    return isoStringWithOffset;
}

export function convertFromISOFormat(isoString: string) {
    if(!isoString) return { dateString: '', timeString: '' };
    const momentDate = moment(isoString);
    const currentDate = moment();

    if (momentDate.isBefore(currentDate, 'day')) {
        return { dateString: '', timeString: '' };
    }

    const isToday = momentDate.isSame(currentDate, 'day');

    const dateString = isToday ? '' : momentDate.format('MMM DD, YYYY');
    const timeString = momentDate.format('h:mm A');

    return { dateString, timeString };
}
export const formatMinutes = (timeLength: number): string => {
    if (!timeLength) return '00';
    const minutes = Math.floor(timeLength / 60);
    return minutes >= 10 ? minutes.toString() : '0' + minutes;
};

export const formatSeconds = (timeLength: number): string => {
    if (!timeLength) return '00';
    const seconds = Math.floor(timeLength % 60);
    return seconds >= 10 ? seconds.toString() : '0' + seconds;
};
export const formatTime = (duration: number) => {
        const minutes = formatMinutes(duration);
        const seconds = formatSeconds(duration);
        return minutes + ':' + seconds;
}
export const weekDays = ['Sunday','Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ];

const CALL_HISTORY_TIME_YESTERDAY_DAYS = 1;
const CALL_HISTORY_TIME_WEEKDAY_CUTOFF_DAYS = 7;

const localCalendarDaysSince = (date: Date, now: Date) => {
    const dateUtc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    const nowUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.round((nowUtc - dateUtc) / (1000 * 60 * 60 * 24));
};

export const formatCallHistoryTime = (input: string | number | Date, now: Date = new Date(), yesterdayLabel: string = 'Yesterday') => {
    if (!input) return '';

    const date = new Date(input);
    if (Number.isNaN(date.getTime())) return '';

    const daysSince = localCalendarDaysSince(date, now);

    if (daysSince <= 0) {
        return new Intl.DateTimeFormat(undefined, {
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    }
    if (daysSince === CALL_HISTORY_TIME_YESTERDAY_DAYS) {
        return yesterdayLabel;
    }
    if (daysSince < CALL_HISTORY_TIME_WEEKDAY_CUTOFF_DAYS) {
        return new Intl.DateTimeFormat('en-US', {weekday: 'short'}).format(date);
    }
    return new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    }).format(date);
};

export const getFormattedDate = (date: any) => {
    const year  = date.getFullYear();
    const  month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day   = date.getDate().toString().padStart(2, "0");
    return year + '.' + month + '.' + day;
}
export const formatDueDate = (dueDate: string) => {
    const now = new Date();
    const due = new Date(dueDate);
    const isToday = now.toDateString() === due.toDateString();
    const isSameYear = now.getFullYear() === due.getFullYear();

    if (isToday) {
        return due.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    } else if (isSameYear) {
        return due.toLocaleString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            day: 'numeric',
            month: 'long'
        }).replace(',', ', ');
    } else {
        return due.toLocaleString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }).replace(',', ', ');
    }
}
export const timezoneList = (() => {
    const timezones = Intl.supportedValuesOf('timeZone');
    const allTimezones: Array<{key: string, value: string, label: string}> = [];

    for (const timezone of timezones) {
        const date = new Date();

        const offsetFormatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: timezone,
            timeZoneName: 'shortOffset'
        });

        const offsetParts = offsetFormatter.formatToParts(date);
        const timeZoneNamePart = offsetParts.find(part => part.type === 'timeZoneName');
        let offsetString = timeZoneNamePart ? timeZoneNamePart.value.replace('GMT', 'UTC') : '';

        if (offsetString && !offsetString.includes(':')) {
            const match = offsetString.match(/UTC([+-])(\d+)/);
            if (match) {
                const sign = match[1];
                const hours = match[2].padStart(2, '0');
                offsetString = `UTC${sign}${hours}:00`;
            }
        }


        const name = timezone.replace(/_/g, ' ');
        const label = `${name} (${offsetString})`;

        allTimezones.push({
            key: timezone,
            value: timezone,
            label: label,
        });
    }

    return allTimezones.sort((a, b) => {
        const getOffsetMinutes = (label: string): number => {
            const match = label.match(/UTC([+-])(\d{1,2}):?(\d{2})?/);
            if (!match) return 0;

            const sign = match[1] === '+' ? 1 : -1;
            const hours = parseInt(match[2], 10);
            const minutes = match[3] ? parseInt(match[3], 10) : 0;

            return sign * (hours * 60 + minutes);
        };

        const offsetA = getOffsetMinutes(a.label);
        const offsetB = getOffsetMinutes(b.label);

        if (offsetA !== offsetB) {
            return offsetA - offsetB;
        }

        return a.label.localeCompare(b.label);
    });
})();
